import Head from './TopHead';
import Curric from './Curric';

function PowerBI() {
    return (
        <main>
            <Head />

            <h1>Microsoft Power BI</h1>

            <section className="section">
                <h2>Power BI Fundamental Skills: 3 Levels</h2>

                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="Power BI - Level 1 Connections & Visualizations (3 Hours)">
                        <ul>
                            <li>Getting Data to Power BI</li>
                            <li>Data Models & Data Types</li>
                            <li>Creating Calculated Columns</li>
                            <li>Creating Relationships Between Models</li>
                            <li>Creating Visualizations</li>
                            <li>DAX Function Basics</li>
                        </ul>
                    </Curric>

                    <Curric title="Power BI - Level 2 POWER QUERY BASICS (3 Hours)">
                        <ul>
                            <li>Prepare & Reshape Data with Power Query</li>
                            <li>Power Query Editor</li>
                            <li>Adding & Transforming Columns</li>
                            <li>Data Types</li>
                            <li>Different Types of Transformations</li>
                            <li>Steps in Power Query</li>
                            <li>Using Append & Merge to Join Data</li>
                            <li>Combine Files in a Folder to a Master Dataset</li>
                            <li>Checking the Steps in Advanced Editor</li>
                        </ul>
                    </Curric>

                    <Curric title="Power BI - Level 3 DAX functions (4 Hours)">
                        <div className="expect">
                            <b>What to Expect:</b> This training revolves around learning Data Analysis Expressions (DAX) in Power BI with hands-on assignments to apply DAX functions and concepts.
                        </div>
                        <ul>
                            <li>Introduction to DAX: Welcome, prerequisites, and the importance of DAX in Power BI.</li>
                            <li>Foundations of DAX: Understanding case study data and its model, introduction to calculated columns, tables, and measures.</li>
                            <li>DAX Functions: Overview of various DAX functions including IF, SWITCH, RELATED, ALL, ALLEXCEPT, VALUES, DISTINCT, SUMX, FILTER, and CALCULATE.</li>
                            <li>Contexts in DAX: Explanation of evaluation and filter contexts, row context within measures, context transition, and using CALCULATE function effectively.</li>
                            <li>Advanced DAX: Techniques like aggregators, iterators (like SUMX), and working with filtered aggregates.</li>
                            <li>Time Intelligence: Techniques for time-based calculations using functions like PREVIOUSMONTH, DATESYTD, TOTALYTD, SAMEPERIODLASTYEAR, and CALENDARAUTO.</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Must have experince with Power BI and very basic DAX functions.</div>
                    </Curric>

                    <Curric title="Power BI - Level 4 POWER QUERY M LANGUAGE (3 Hours)">
                        <ul>
                            <li>Advanced Editor in Power Query</li>
                            <li>M Language Basics</li>
                            <li>Traversing Lists and Tables</li>
                            <li>If Statements in M Language</li>
                            <li>Using Functions in M Language for Advanced Transformations</li>
                            <li>Creating Custom Functions</li>
                            <li>Applying a Custom Function to a Column</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Some programming experience is recommended.</div>
                    </Curric>
                </div>
            </section>

            <hr />

        </main>

    );
}

export default PowerBI;